import { configureStore } from '@reduxjs/toolkit'
import { getRootState } from 'fwork.react.apptemplate'
import { useDispatch } from 'react-redux'
// PRA EXECUTAR DISPATCH COM FUNCOES PRECISA DO THUNK
// SE NAO TIVER O THUNNK GERA O ERRO
// Uncaught (in promise) Error: Actions must be plain objects. Instead, the actual type was: 'function'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions
import thunk from 'redux-thunk'
import { IUser } from 'bets.oddprovider.lib.common.ts/models'

import { persistStore } from 'redux-persist'
// import { IUser } from '../model'
import { persistedAuthorizationsReducer } from './persistors/authorizations'
import { persistedCompaniesReducer } from './persistors/companies'
import { persistedEventsReducer } from './persistors/events'
import { persistedLocationsReducer } from './persistors/locations'
import { persistedParticipantsReducer } from './persistors/participants'
import { persistedSportsReducer } from './persistors/sports'
import { persistedTournamentsReducer } from './persistors/tournaments'
import { persistedUserGroupsReducer } from './persistors/userGroups'
import { persistedUsersReducer } from './persistors/users'
import { persistedUsersLogsReducer } from './persistors/usersLogs'
import { persistedUsersLogsGroupsReducer } from './persistors/usersLogsGroups'
import { persistedScoreTypesReducer } from './persistors/scoreTypes'
import dotEnvProductionReducer, { dotEnvProductionStateLoadFromApi } from './reducers/dotenvProduction.slice'
import loadingBarReducer from './reducers/loadingBar.slice'
import localSettingsReducer from './reducers/localSettings.slice'
import tasksReducer, { clearDbTasks } from './reducers/tasks.slice'
import { clearAuthorizations } from './reducers/authorizations.slice'
import { clearEvents } from './reducers/events.slice'
import { clearLocations } from './reducers/locations.slice'
import { clearParticipants } from './reducers/participants.slice'
import { clearSports } from './reducers/sports.slice'
import { clearTournaments } from './reducers/tournaments.slice'
import { clearUserGroups } from './reducers/userGroups.slice'
import { clearUsersLogs } from './reducers/usersLogs.slice'
import { clearUserLogsGroups } from './reducers/usersLogsGroups.slice'
import { clearUsers } from './reducers/users.slice'
import { clearCompanies } from './reducers/companies.slice'
import { clearCompaniesGroups } from './reducers/companiesGroups.slice'
import { persistedCompaniesGroupsReducer } from './persistors/companiesGroups'
import { clearScoreTypes } from './reducers/scoreTypes.slice'

export const store = configureStore({
  reducer: {
    ...getRootState<IUser>(),
    dotEnvProductionState: dotEnvProductionReducer,
    localSettingsState: localSettingsReducer,
    loadingBarState: loadingBarReducer,
    tasksState: tasksReducer,
    sportsState: persistedSportsReducer,
    tournamentsState: persistedTournamentsReducer,
    participantsState: persistedParticipantsReducer,
    eventsState: persistedEventsReducer,
    locationsState: persistedLocationsReducer,
    usersState: persistedUsersReducer,
    userGroups: persistedUserGroupsReducer,
    authorizationsState: persistedAuthorizationsReducer,
    usersLogsState: persistedUsersLogsReducer,
    usersLogsGroupsState: persistedUsersLogsGroupsReducer,
    companiesState: persistedCompaniesReducer,
    companiesGroupsState: persistedCompaniesGroupsReducer,
    scoreTypesState: persistedScoreTypesReducer,
  },
  middleware: [thunk],
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const persistor = persistStore(store)

store.dispatch<any>(dotEnvProductionStateLoadFromApi())

export const clearReducers = [
  clearCompanies,
  clearCompaniesGroups,
  clearAuthorizations,
  clearEvents,
  clearLocations,
  clearParticipants,
  clearSports,
  clearTournaments,
  clearUserGroups,
  clearUsersLogs,
  clearUserLogsGroups,
  clearUsers,
  clearDbTasks,
  clearScoreTypes
]